import { useRef } from "react";

import CameraCapture from "../CameraCapture";

import type { ChangeEventHandler } from "react";

interface CaptureDialogInputProps {
  capturedImage: string | null;
  onCapture: (dataUrl: string) => void;
  onRetake: () => void;
}

export const CaptureDialogInput = ({
  capturedImage,
  onCapture,
  onRetake,
}: CaptureDialogInputProps) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  return (
    <div className="capture-dialog-input">
      {!capturedImage ? (
        <CameraCapture onCapture={onCapture} />
      ) : (
        <div className="space-y-3">
          <div
            className="relative bg-muted rounded-md overflow-hidden"
            style={{ aspectRatio: "16 / 9" }}
          >
            <img
              src={capturedImage}
              alt="Captured"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
          <button
            type="button"
            className="capture-btn capture-btn-outline"
            onClick={onRetake}
          >
            Retake
          </button>
        </div>
      )}
    </div>
  );
};
